import { render, staticRenderFns } from "./QuizTeacherCreateTitle.vue?vue&type=template&id=9401381c&"
import script from "./QuizTeacherCreateTitle.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherCreateTitle.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherCreateTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports